import React from 'react'
import { string } from 'prop-types'
import { EventGrid } from '@/component/Primitive/Events'

const EventGridWidget = (props) => <EventGrid {...props} />

EventGridWidget.propTypes = {
  title: string,
  description: string
}

export default EventGridWidget
